export default "__VITE_PUBLIC_ASSET__781b9170__"